exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fee[data-v-5d4ae864] {\n  position: relative;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  z-index: 2;\n}\n.fee .fee-table__type[data-v-5d4ae864] {\n    font-weight: 600;\n}\n.fee .fee-table__subtype[data-v-5d4ae864] {\n    color: #578AD6;\n}\n.fee__asset-info[data-v-5d4ae864] {\n  margin-bottom: 2rem;\n}\n.fee__header[data-v-5d4ae864] {\n  padding: 1.5rem 1.5rem 0;\n  font-weight: 600;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d4ae864","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/fee/index/Fee.Index.vue
// module id = TKkT
// module chunks = 1